import * as React from 'react';
import { observer } from 'mobx-react';
import { ITicketSelection } from '../models/mtsTicket/ticketSelection';
import { TicketSelection } from 'common--design-library';
import { OfferType } from '../api/proto/apiContract';

export interface ITicketTipsContainerProps {
    tips: ITicketSelection[];
    isEnabledUI: boolean;
    canShowBanker: boolean;
    canShowAliasNumber: boolean;
    isForOneTapBet: boolean;

    changeIsBanker?: (selection: ITicketSelection, value: boolean) => void;
    removeTip: (ident: string) => void;
    onGoToDetail: (eventId: number, offerType: OfferType) => void;
}

@observer
export class TicketTipsContainer extends React.Component<ITicketTipsContainerProps> {
    render() {
        return <React.Fragment>
            {this.props.tips.map((tip: ITicketSelection) =>
                <TicketSelection
                    key={tip.id}
                    tip={tip}
                    changeIsBanker={this.props.changeIsBanker}
                    removeTip={this.props.removeTip}
                    errors={[...tip.errors]}
                    isEnabledUI={this.props.isEnabledUI}
                    goToDetail={() => { this.props.onGoToDetail(tip.fixtureId, tip.offerType); }}
                    canShowBanker={this.props.canShowBanker}
                    canShowAliasNumber={this.props.canShowAliasNumber}
                    isForOneTapBet={this.props.isForOneTapBet}
                />
            )
            }
        </React.Fragment>
    }
}